<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Prorrogações
          <b-button size="sm" class="float-right m-1" to="/seguranca-administracao/prorrogacoes/novo">
            <font-awesome-icon icon="plus" class="mr-3" />
            Nova Prorrogação
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <card-filtros-busca>
          <b-form @submit.prevent="buscarProrrogacoes" @reset.prevent="limparFiltros" v-if="showFilters">
            <b-row>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-type" label-size="md" label="Busca Geral">
                  <b-form-input v-model="filtros.buscaGeral"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-type" label-size="md" label="Exercício (ano)">
                  <b-form-select id="select-filtros-exercicio" v-model="filtros.exercicio" :options="comboExercicios">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-type" label-size="md" label="Referência (mês)">
                  <b-form-select id="select-filtros-referencia" v-model="filtros.referencia" :options="comboReferencias">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="2">
                <b-form-group id="input-group-type" label-size="md" label="Tipo Prorrogação">
                  <b-form-select id="select-filtros-referencia" v-model="filtros.tipoProrrogacao"
                    :options="comboTipoProrrogacao">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4" class="wrapper-multiselect-sagres">
                <b-form-group id="input-group-type" label-size="md" label="Unidade Gestora">
                  <multiselect v-model="filtros.selectedUG" open-direction="bottom" :close-on-select="true"
                    :searchable="true" label="Nome" :show-labels="false" deselect-label="" :allow-empty="true"
                    placeholder="Selecione" track-by="Codigo" :options="optionsUG">
                    <template slot="noOptions">
                      <small><i>Erro ao obter dados.</i></small>
                    </template>
                    <template slot="noResult">
                      <i>Sem resultados.</i>
                    </template>
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="3" class="pt-4">
                <b-button style="margin-top:5px" type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="3" class="pt-4">
                <b-button style="width:100%; margin-top:5px;" type="submit">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>

        </card-filtros-busca>
        <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
          striped stacked="sm" per-page="10" :current-page="currentPage" show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(TipoRel)="row">
            {{ row.item.TipoRel ? row.item.TipoRel : '-' }}
          </template>
          <template v-slot:cell(PeriodoRel)="row">
            {{ row.item.PeriodoRel ? row.item.PeriodoRel : '-' }}
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" @click="editarProrrogacao(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <btn-excluir :idItem="row.item.IdProrrogacao" :excluirItem="removerProrrogacao" />
            </div>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="items.length" per-page="10" aria-controls="my-table" />
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'
import prorrogacaoService from "@/services/administracao/prorrogacaoService"
import { store } from "@/store"
import Multiselect from "vue-multiselect";
import { FiltrosProrrogacoes } from '@/types/administracao/filtros-prorrogacoes'
import { ReferenciasValidas } from '@/types/administracao/referencias-validas'
import { SelectValue } from '@/types/select-value'
import { fieldsProrrogacoes } from '@/types/administracao/fields-prorrogacoes'
import { TableField } from '@/types/table-field'
import { Prorrogacoes } from '@/types/administracao/prorrogacoes'
import { UnidadeGestoraResumida } from '@/types/ug/unidade-gestora-resumida';
import ugService from "@/services/administracao/ugService"
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'

const CompProps = Vue.extend({
  name: 'Prorrogacoes',
  components: { BtnExcluir, CardFiltrosBusca, Multiselect },
})

@Component
export default class Prorrogacao extends mixins(UtilsTS, CompProps) {
  comboExercicios: SelectValue[] = []
  comboReferencias: SelectValue[] = []
  comboTipoProrrogacao: SelectValue[] = []
  optionsUG: UnidadeGestoraResumida[] = []
  currentPage = 1
  isBusy = false
  fields: TableField[] = fieldsProrrogacoes
  filtros: FiltrosProrrogacoes = new FiltrosProrrogacoes()
  items: Prorrogacoes[] = []
  showFilters = true
  tableBusy = false

  async mounted() {
    try {
      store.blockScreen = true

      const ano = new Date().getFullYear()
      this.comboExercicios = [
        { text: String(ano - 1), value: ano - 1 },
        { text: String(ano), value: ano },
        { text: String(ano + 1), value: ano + 1 },
      ]
      this.comboReferencias = ReferenciasValidas.map(r => {
        return { text: String(r), value: r }
      })
      this.comboTipoProrrogacao = (await prorrogacaoService.buscarTiposProrrogacao()).data.map(r => {
        return { text: String(r), value: r }
      })
      await this.obterUgsAtivas()

    } finally {
      store.blockScreen = false
    }
  }

  async buscarProrrogacoes(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await prorrogacaoService.buscarProrrogacoes(this.filtros);
      if (response && response.status === 200) {
        this.items = response.data.map((pr: any) => {
          const retorno = Object.assign(new Prorrogacoes(), pr)
          retorno.tratarDadosDaAPI()
          return retorno
        })
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
      }
    } catch (e: any) {
      console.error(e)
      this.items = []
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.tableBusy = false
    }
  }
  limparFiltros(): void {
    this.filtros.limpar()
    // Trick to reset/clear native browser form validation state
    this.showFilters = false
    this.$nextTick(() => {
      this.showFilters = true
    })
  }

  async obterUgsAtivas(): Promise<void> {
    try {
      const response = await ugService.obterUgsAtivas()
      if (response && response.status === 200) {
        this.optionsUG = this.formatedUGLabels(response.data)
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao buscar UGs ativas!')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.isBusy = false
    }
  }

  async removerProrrogacao(id: number): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await prorrogacaoService.removerProrrogacoes(id)
      if (resp && resp.status === 204) {
        this.buscarProrrogacoes()
        this.$toast.success("Prorrogação excluída com sucesso")
      } else {
        console.error('Erro ao remover prorrogação', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover prorrogação!')
      }
    } catch (e: any) {
      console.error('Erro ao remover prorrogação', e)
      this.$toast.error(e.message || 'Erro ao remover prorrogação')
    } finally {
      store.blockScreen = false
    }
  }

  editarProrrogacao(prorrogacaoAEditar: Prorrogacoes) {
    this.$router.push(`/seguranca-administracao/prorrogacoes/editar/${prorrogacaoAEditar.IdProrrogacao}`);
  }
};
</script>

<style>
.col-actions {
  min-width: 130px;
}
</style>